export const USER_MEXICO = "drvideo@doctor.video"
export const PASSWORD_MEXICO = "!Sys73xrv21"

export const USER_COLOMBIA = "drvideocolombia@doctor.video"
export const PASSWORD_COLOMBIA = "!Sys73xrv21"